<h4 for="label">{{variables.cecosManagement}}</h4>

<div style="display: flex; align-items: center;">
  <mat-form-field appearance="outline">
    <input matInput placeholder="{{variables.search}}..." search (keyup)="searchCECOS($event)" />
  </mat-form-field>

  <div style="margin-left: auto;">
    <app-button typeBtn="primary" (click)="importDataFromExcel()" message="{{variables.fromExcel}}"></app-button>
  </div>
</div>

<!-- manage ceco's and gcm's table -->
<div>
  <br>
  <div class="mat-elevation-z0">
    <table mat-table [dataSource]="dataSource" class="gcm-table">

      <!-- Cost Center -->
      <ng-container matColumnDef="costCenter">
        <th mat-header-cell *matHeaderCellDef width="17%">
          <strong>
            {{variables.costType}}
          </strong>
        </th>
        <td mat-cell *matCellDef="let element" width="17%" [attr.data-header]="variables.costType">
          <div>{{element.costCenter}}</div>
        </td>
      </ng-container>

      <!-- GCM's -->
      @for (i of [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]; track i) {
      <ng-container matColumnDef="gcm{{i}}">
        <th mat-header-cell *matHeaderCellDef width="7%">
          <strong>
            {{i}} (€)
          </strong>
        </th>
        <td mat-cell *matCellDef="let element" width="7%" [attr.data-header]="i + ' (€)'">
          <div>{{element.gcms[i]}}</div>
        </td>
      </ng-container>
      }

      <!-- ACTIONS -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef width="7%"></th>
        <td mat-cell *matCellDef="let element" style="justify-content: end;" width="7%" [attr.data-header]="'Actions'">
          <div class="action_buttons">
            <span (click)="editValues(element)" class="action_buttons-item" style="margin-right: 10px;">
              <img src="../../../../assets/svg/EditWhite.svg" alt="Edit Icon" width="20px">
            </span>
          </div>
        </td>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns1"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns1;"></mat-row>
    </table>
    <mat-paginator class="paginator-borders" #paginator [length]="dataSource.data.length" [pageIndex]="0"
      [pageSize]="10" [pageSizeOptions]="[5, 10, 20]" aria-label="Select page"></mat-paginator>
  </div>
</div>